import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { WebPushListPage } from './list';
import { WebPushMessageViewPage } from './view';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';

export const WebPushModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Web Push Messaging', path: '.' }]));
  }, []);

  return (
    <PageContentWrapper>
      <Routes>
        <Route path=":id/*" element={<WebPushMessageViewPage />} />
        <Route path="/*" element={<WebPushListPage />} />
      </Routes>
    </PageContentWrapper>
  );
};
